import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../global/Spinner';
import AlbumFolderPurchaseSelectAccountIdentitiesContainer from '../../../containers/purchase/album-folder-purchase/AlbumFolderPurchaseSelectAccountIdentitiesContainer';
import Button from '../../global/Button';
import {
  isAlbumFolderTagSelectionRequiredForCheckout,
  canSelectActivitities,
} from '../../../util/album-folder';
import WaldoSpeechBubble from '../../global/WaldoSpeechBubble';
import OnboardingLayoutFooter from '../../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutFooter';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  loading: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  selectedIdentities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  identities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  resetTagSelection: PropTypes.func,
};

const AlbumFolderPurchaseSelectIdentities = ({
  albumFolder,
  loading,
  history,
  selectedIdentities,
  identities,
  tags,
  resetTagSelection,
}) => {
  const onGoToCheckout = event => {
    event.preventDefault();

    if (
      isAlbumFolderTagSelectionRequiredForCheckout(albumFolder) &&
      canSelectActivitities(tags)
    ) {
      resetTagSelection();
      history.replace(`/purchase/album-folder/${albumFolder.id}/activities`);
    } else {
      history.replace(
        `/purchase/album-folder/${albumFolder.id}/purchase-summary`,
      );
    }
  };

  const hasIdentities = (identities?.length ?? 0) > 0;

  if (loading || !albumFolder) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <WaldoSpeechBubble position="right" className="mb-4">
        Who do you want me to look for in this gallery?
      </WaldoSpeechBubble>

      <AlbumFolderPurchaseSelectAccountIdentitiesContainer />

      {hasIdentities && selectedIdentities.length > 0 && (
        <OnboardingLayoutFooter>
          {hasIdentities && (
            <Fragment>
              <Button
                onClick={onGoToCheckout}
                btnBlock
                className="mt-3"
                disabled={selectedIdentities.length === 0}
              >
                Continue
              </Button>
              <Button
                onClick={() => history.goBack()}
                btnBlock
                btnStyle="link"
                className="mt-1 text-center text-bold"
              >
                Go Back
              </Button>
            </Fragment>
          )}
        </OnboardingLayoutFooter>
      )}
    </Fragment>
  );
};

AlbumFolderPurchaseSelectIdentities.propTypes = propTypes;

export default AlbumFolderPurchaseSelectIdentities;
